export default [
  {
    key: 'sticky',
    type: 'bool',
    description: ''
  },
  {
    key: 'class',
    type: 'string',
    description: ''
  }
]
